import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'

import { updateInputs } from '../../actions/solicitudservicioot'


class Cancelacion extends Component {

	render() {

        const { solicitud } = this.props

		return (
            <div>

                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label htmlFor="fecha_rechazo" className="control-label" >Fecha de cancelación</label>
                            <input type="date" className="form-control input-sm" name="fecha_rechazo" id="fecha_rechazo" value={moment(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD') || ''} disabled />
                        </div>
                    </div>
                </div>    


                <BoxSection title="Motivo de cancelación">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea type="text" className="form-control input-sm" rows={4} value={ solicitud.get('motivo_cancelacion') || '' } onChange={ (e) => this.props.updateInputs('solicitud.motivo_cancelacion', e.target.value) } disabled = { solicitud.get('estado') == 0 } />
                            </div>
                        </div>
                    </div> 

                </BoxSection>
                
                <ModalConfirmarAccion />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        solicitud: state.solicitudservicioot.get('solicitud'),
    }
}


function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cancelacion)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicioOT/Cancelacion.jsx